import React from 'react'
import { Link } from "gatsby"

export default function ContactMe() {
  return (
    <div className="cta_contactSection">
      <div className="text">Un projet en tête ? Prenons contact</div>
      <Link to="/contact">
        <div className="cta_contactBtn">Me contacter</div>
      </Link>
    </div>
  )
}
